import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthTokenService } from '../services/auth-token.service';
import { appConstants } from '../app-constants';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
  standalone: false
})
export class PasswordResetComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  errorMessage = '';
  successMessage = '';
  authenticityToken!: string;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authTokenService: AuthTokenService
  ) {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  async ngOnInit() {
    this.authenticityToken = await this.authTokenService.getAuthenticityToken(true)
  }

  async onSubmit(): Promise<void> {
    this.submitted = true;
    this.errorMessage = '';
    this.successMessage = '';

    if (this.form.invalid) {
      return;
    }

    let body = encodeURIComponent("user[email]") + "=" + encodeURIComponent(this.form.value.email)

    let response = await fetch(environment.legacyAppUrl + "/users/password", {
      "headers": {
        "accept": "application/json",
        "content-type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": this.authenticityToken
      },
      "body": body,
      "method": "POST",
      "credentials": 'include'
    });

    this.successMessage = 'If an account exists for this email, you will receive password reset instructions shortly.';
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 5000);
  }

  logoUrl(): string {
    return appConstants.LOGO_URL;
  }
} 